<template>
  <div class="header-steps py-4 px-2 flex items-center justify-between border-b gap-3 border-grayLight dynamic-height dynamic-width-main">
    <div class="text-dark flex items-center dynamic-width-left">
      <button class="font-medium text-base mt-[3px] pr-3 mr-3 border-r border-r-grayLight" @click="goBack">
        <i class="el-icon-back"></i>
        Back
      </button>
      <div>
        <div class="flex items-center gap-1">
          <el-tooltip popper-class="title-tooltip" effect="dark" :content="title" placement="bottom-start">
            <div class="text-24px font-bold truncate page-title">{{ title }}</div>
          </el-tooltip>

          <slot name="action-menu"></slot>
        </div>
        <slot name="status"></slot>
      </div>
    </div>

    <div class="flex items-center dynamic-width-center">
      <slot name="tabs">
        <!-- steps -->
        <div v-if="steps.length" class="steps flex items-center gap-3.5">
          <div
            v-for="(step, index) in steps"
            :key="index"
            class="flex items-center justify-center gap-0.5 after:w-[96px] after:bg-grayLight after:h-[1px] after:last:hidden after:ml-2"
            :class="{
              completed: index < active,
              active: index === active || (index === 1 && isActivePeriod),
              inactive: index > active,
              error: formDataValidate && formDataValidate.step === index && !formDataValidate?.valid,
            }"
            @click="changeStep(index)"
          >
            <!--  @click="changeStep(index)" -->
            <template v-if="index < active">
              <svg v-if="loading.status && loading.step === index" width="24" height="24" fill="none">
                <use :xlink:href="`#loading`"></use>
              </svg>
              <svg v-else width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" width="24" height="24" rx="12" fill="#66C756" />
                <path d="M7 13.5L10 16.5L18 7.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </template>
            <template v-else>
              <span class="rounded-full w-[24px] h-[24px] flex items-center justify-center text-white font-bold">{{ index + 1 }}</span>
            </template>

            {{ step }}
          </div>
        </div>
        <!-- end step -->
      </slot>
    </div>
    <div class="flex items-center gap-1 dynamic-width-right">
      <slot name="actions"></slot>
    </div>
  </div>
</template>
<script>
import ModalDiscardChanges from '@/components/social-products/social-boost/modal/ModalDiscardChanges.vue'
import SocialBoostCampaignMixin from '@/mixins/social-products/social-boost-campaign'

export default {
  name: 'HeaderSteps',
  mixins: [SocialBoostCampaignMixin],
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Number,
      default: 0,
    },
    backPath: {
      type: null,
      default: -1,
    },
    dialog: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    formDataValidate: {
      type: [Boolean, Object],
      default: false,
    },
  },
  data() {
    return {
      loading: {
        status: false,
        step: 0,
      },
    }
  },
  computed: {
    activeStep() {
      return this.steps[this.active - 1]
    },
    isActivePeriod() {
      return this.$store.getters['socialBoostCampaign/campaignForm']?.periodBudget ? true : false
    },
    type() {
      return this.$route.params.type
    },
  },

  methods: {
    async changeStep(index) {
      if ((this.steps[index] && index < this.active) || this.isActivePeriod) {
        this.loading = {
          status: true,
          step: index,
        }
        await this.updateStoreFormDetails(false)
        this.loading = {
          status: false,
          step: index,
        }
        const query = { ...this.$route.query }

        if (index === 0) {
          delete query.step
          delete query.flight
        } else {
          query.step = index
        }

        this.$router.push({ query })
        //this.goBack()
      }
    },
    goBack() {
      if (this.backPath !== -1) {
        this.$router.push(this.backPath)
      } else {
        this.$router.go(-1)
      }
    },
    openModal() {
      this.$Modal.init(
        {
          propsData: {
            component: ModalDiscardChanges,
            meta: { backPath: this.backPath },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
              console.log('>>>>>')
            }
          },
        },
        this
      )
    },
  },
}
</script>
<style lang="scss">
.header-steps {
  .completed {
    @apply cursor-pointer;
  }
  .steps {
    .inactive {
      @apply text-bordersDark;
      span {
        @apply bg-bordersDark;
      }
    }
    .active {
      @apply text-primary font-medium;
      span {
        @apply bg-primary;
      }
      &.error {
        @apply text-danger;
        span {
          @apply bg-danger;
        }
      }
    }
    .completed {
      @apply text-muted;
      span {
        @apply bg-success;
      }
    }
  }
  .page-title {
    max-width: 320px;
  }
}
.el-tooltip__popper.title-tooltip {
  @apply text-13px font-bold;
  max-width: 500px;
}
</style>
